/**
 * Compare / Vergleichsliste - Model Inforamtion Handler
 *
 * Filename: 420_compare_model_information_handler.js
 *
 * @category  Applicas
 * @package   Slider
 * @author    Janik Kemnade <j.kemnade@fahrrad-xxl.de>
 * @copyright 2022 Fahrrad XXL
 */


export default class FxxlCompareModelInformationHandler {

    constructor(container) {
        // Classnames & Ids
        this.informationGroupsClassName = 'fxxl-accordion';
        this.informationGroupHeadClassName = 'fxxl-accordion__head';
        this.informationGroupDeactivatedClassName = 'fxxl-accordion--deactivated';

        // Variables
        this.container = container;
        this.groupElements = null; // groupElements short for informationGroupElements
        this.groups = null;
        this.comparisonGroup = null;
        this.comparisonTopic = null;

        // Init
        this.groupElements = this.container.querySelectorAll(`.${this.informationGroupsClassName}`);
        if (this.groupElements.length === 0) return;

        this.setupGroupsObject();
        this.initEvents();
    }

    setupGroupsObject() {
        this.groups = [];

        this.groupElements.forEach((element, index) => {
            const head = element.querySelector(`.${this.informationGroupHeadClassName}`);
            const topic = head.textContent || '';

            this.groups.push({
                element: element,
                head: head,
                topic: topic,
                index: index,
                extended: element.dataset.extended,
                comparisonGroup: element.dataset.comparisonGroup,
                comparisonTopic: topic,
            });
        });
    }

    initEvents() {
        this.groups.forEach(group => {
            group.head.addEventListener('click', () => {
                this.toggleGroup(group);
            });
        })
    }

    toggleGroup(clickedGroup) {
        requestAnimationFrame(() => {
            const groupStatus = clickedGroup.element.classList.contains(this.informationGroupDeactivatedClassName);
            this.setGroupExtendedStatus(clickedGroup, groupStatus);
            this.sendRequest(clickedGroup.index, clickedGroup.extended);
        });
    }

    setGroupExtendedStatus(clickedGroup, status) {
        clickedGroup.extended = (status === true) ? '0' : '1';
        clickedGroup.element.dataset.extended = clickedGroup.extended;
        this.comparisonGroup = clickedGroup.element.dataset.comparisonGroup;
        this.comparisonTopic = clickedGroup.topic.trim().split(' ').join('-');
    }

    sendRequest(index, extendedStatus) {
        let request = '/json.php?service=';
        request += 'updateModelInformationGroupOfCompareList';
        request += `&index=${index}`;
        request += `&status=${extendedStatus}`;
        request += `&comparison_group=${this.comparisonGroup}`;
        request += `&comparison_topic=${encodeURIComponent(this.comparisonTopic)}`;

        fetch(request)
            .catch((error) => console.warn('Error:', 'FxxlCompareModelInformationHandler.sendRequest', error) );
    }
}
